import { createFileRoute } from "@tanstack/react-router";
import { preloadSourcingWebsitesQueries } from "@/pages/admin-sourcing-websites/api/preload-sourcing-websites-queries";
import { searchParams } from "@/pages/admin-sourcing-websites/model/search-params";
import { SourcingWebsitesPage } from "@/pages/admin-sourcing-websites/ui/sourcing-websites-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/sourcing/websites/",
)({
  component: SourcingWebsitesPage,
  loaderDeps: ({ search }) => search,
  loader: ({ deps }) => preloadSourcingWebsitesQueries(deps),
  validateSearch: searchParams,
});
